<template>
  <div id="login">
    <v-container>
      <v-row>
        <v-col class="pt-4" cols="12">
          <div>
            <span
              class="home-intro-large pt-2 pb-0"
              v-html="$t('login.title')"
            ></span>
          </div>
        </v-col>
      </v-row>

      <v-row class="pt-6 pb-1">
        <v-col cols="12">
          <youtube
            :video-id="$t('login.videoId')"
            player-width="876"
            player-height="493"
            :player-vars="{ autoplay: 1 }"
          ></youtube>
        </v-col>
      </v-row>

      <v-row align="center" class="pt-8 pb-4">
        <v-col align="center" sm="6" md="3">
          <img :src="require('@/assets/logos/ASSU_logo.png')" width="100px" />
        </v-col>
        <v-col align="center" sm="6" md="3">
          <img :src="require('@/assets/logos/AXA_logo.png')" />
        </v-col>
        <v-col align="center" sm="6" md="3">
          <img :src="require('@/assets/logos/logo_Belfius_Insurance.png')" />
        </v-col>
        <v-col align="center" sm="6" md="3">
          <img
            :src="require('@/assets/logos/Federale_fr_logo.png')"
            v-if="currentLocale == 'fr'"
          />
          <img :src="require('@/assets/logos/Federale_nl_logo.png')" v-else />
        </v-col>
      </v-row>

      <v-row align="center" class="pb-10">
        <v-col align="center" sm="6" md="3">
          <img :src="require('@/assets/logos/KBC_logo.png')" />
        </v-col>
        <v-col align="center" class="pt-3" sm="6" md="3">
          <img :src="require('@/assets/logos/PV_logo.png')" />
        </v-col>
        <v-col align="center" class="pt-3" sm="6" md="3">
          <img :src="require('@/assets/logos/VanBreda_logo.png')" />
        </v-col>
        <v-col align="center" sm="6" md="3">
          <img :src="require('@/assets/logos/AG_logo.png')" />
        </v-col>
      </v-row>

      <!--       <v-row align="center" class="pb-4">
        <v-col align="center" cols="12">
          <div class="home-title-large pt-3 pb-2">
            {{ $t("login.csInfo.title") }}
          </div>
        </v-col>
      </v-row> -->

      <!--       <v-row align="center" class="pb-8">
        <v-col cols="12">
          <span
            class="text-h6 font-weight-regular"
            v-html="$t('login.csInfo.details')"
          ></span> </v-col
      ></v-row> -->

      <!--       <v-row align="center" class="pb-8">
        <v-col cols="12">
          <template>
            <v-simple-table>
              <template>
                <thead>
                  <tr>
                    <th class="text-left text-subtitle-1 font-weight-bold">
                      {{ $t("login.priceTable.header1") }}
                    </th>
                    <th class="text-left text-subtitle-1 font-weight-bold">
                      <span v-html="$t('login.priceTable.header2')"></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span v-html="$t('login.priceTable.1.1')"></span>
                    </td>
                    <td>
                      <span v-html="$t('login.priceTable.1.2')"></span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span v-html="$t('login.priceTable.2.1')"></span>
                    </td>
                    <td>
                      <span v-html="$t('login.priceTable.2.2')"></span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span v-html="$t('login.priceTable.3.1')"></span>
                    </td>
                    <td>
                      <span v-html="$t('login.priceTable.3.2')"></span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span v-html="$t('login.priceTable.4.1')"></span>
                    </td>
                    <td>
                      <span v-html="$t('login.priceTable.4.2')"></span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template> </v-col
      ></v-row> -->

      <v-row class="pt-8">
        <v-col cols="12" md="6" class="pr-md-12 pr-sm-0">
          <div class="cs-form-intro-small pt-3 pb-5">{{ loginFormTitle }}</div>
          <form v-if="showLoginForm" @submit.prevent>
            <label for="email1">{{ $t('login.email') }}</label>
            <input
              v-model.trim="loginForm.email"
              type="text"
              placeholder="you@email.com"
              id="email1"
            />

            <label for="password1">{{ $t('login.password') }}</label>
            <input
              v-model.trim="loginForm.password"
              type="password"
              placeholder="******"
              id="password1"
            />

            <button @click="login" class="button">Log In</button>

            <div class="extras pt-8">
              <a @click="togglePasswordReset">
                {{ $t('login.passwordForgotten') }}
              </a>
            </div>
          </form>

          <form
            v-if="showForgotPassword"
            @submit.prevent
            class="password-reset"
          >
            <div v-if="!passwordResetSuccess">
              <p>{{ $t('login.resetPasswordEmailSent') }}</p>

              <label for="email3">Email</label>
              <input
                v-model.trim="passwordForm.email"
                type="text"
                placeholder="you@email.com"
                id="email3"
              />

              <button @click="resetPassword" class="button">
                {{ $t('login.button.submit') }}
              </button>

              <div class="extras pt-8">
                <a @click="togglePasswordReset">{{
                  $t('login.backToLogin')
                }}</a>
              </div>
            </div>
            <div v-else>
              <p>{{ $t('login.emailSentConfirmation') }}</p>
              <button @click="togglePasswordReset" class="button">
                {{ $t('login.backToLogin') }}
              </button>
            </div>
          </form>
          <transition name="fade">
            <div v-if="errorMsg !== ''" class="error-msg">
              <p>{{ errorMsg }}</p>
            </div>
          </transition>
        </v-col>

        <v-col cols="12" md="6" class="pr-md-12 pr-sm-0 pl-4">
          <div class="cs-form-intro-small pt-3 pb-8">
            {{ $t('login.noAccount') }}
          </div>
          <div class="pb-8">
            <button @click="createAccount" class="button">
              {{ $t('login.button.createAccount') }}
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
const fb = require('../firebaseConfig.js');
export default {
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      signupForm: {
        name: '',
        title: '',
        email: '',
        password: '',
      },
      passwordForm: {
        email: '',
      },

      showLoginForm: true,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: '',
    };
  },
  computed: {
    loginFormTitle: function () {
      if (this.showForgotPassword) {
        return this.$t('login.resetPassword');
      } else if (this.passwordResetSuccess) {
        return this.$t('login.emailSent');
      } else {
        return this.$t('login.pleaseIdentifyYourself');
      }
    },
    currentLocale: function () {
      return this.$i18n.locale;
    },
  },
  methods: {
    toggleForm() {
      this.errorMsg = '';
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.errorMsg = '';
      if (this.showForgotPassword) {
        this.showLoginForm = true;
        this.showForgotPassword = false;
        this.passwordResetSuccess = false;
      } else {
        this.showLoginForm = false;
        this.showForgotPassword = true;
      }
    },
    login() {
      // this.performingRequest = true;

      let email = this.loginForm.email;
      let isnum = /^\d+$/.test(email);

      if (isnum) {
        email = email + '@a2.fr';
      }

      fb.auth
        .signInWithEmailAndPassword(email, this.loginForm.password)
        .then((userCredential) => {
          this.$store.commit('SET_CURRENT_USER', userCredential.user);
          this.$store.dispatch('fetchUserProfile');
          //this.performingRequest = false;
          this.$router.push('/upload');
        })
        .catch((err) => {
          //this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    resetPassword() {
      fb.auth
        .sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.passwordResetSuccess = true;
          this.passwordForm.email = '';
        })
        .catch((err) => {
          this.errorMsg = err.message;
        });
    },
    createAccount() {
      this.$router.push('/register');
    },
  },
};
</script>
<style scoped>
.home-intro-large {
  background-color: #ffffff;
  font-family: 'Raleway', sans-serif !important;
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.4;
  color: #1976d2;
  margin-bottom: 20px;
}

.home-title-large {
  background-color: #ffffff;
  font-family: 'Raleway', sans-serif !important;
  font-size: 36px;
  font-style: normal;
  font-weight: 900;
  color: #164396;
}

body {
  margin: 0;
  background: #ffffff;
}
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}
* {
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
  transition: 0.15s;
}
*:focus {
  outline: none;
}
h1,
h2,
h3,
h4,
h5,
p {
  margin: 0 0 0.5rem;
}
h1 {
  font-size: 2rem;
}
h2 {
  font-size: 1.8rem;
}
h3 {
  font-size: 1.6rem;
}
h4 {
  font-size: 1.4rem;
}
h5 {
  font-size: 1.2rem;
}
p {
  line-height: 1.5;
}
a {
  font-family: 'Roboto', sans-serif;
  text-decoration: none;
  color: #d32f2f;
  margin: 0;
  cursor: pointer;
}
a:hover {
  color: #d32f2f;
}
section {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
}
@media screen and (max-width: 742px) {
  section {
    display: block;
  }
}
.col1,
.col2 {
  flex-grow: 1;
  flex-basis: 0;
  padding: 1rem;
}
[v-cloak] {
  display: none;
}
.error-msg {
  margin-top: 2rem;
  text-align: left;
  font-size: 15px;
  padding-left: 68px;
}
.error-msg p {
  color: #d32f2f;
  margin: 0;
}
.button {
  background: #1976d2;
  border: 0;
  outline: 0;
  color: #fff;
  padding: 0.8rem 1rem;
  min-width: 150px;
  font-size: 16px;
  border-radius: 3px;
  cursor: pointer;
}
.button:hover {
  background: #1976d2;
}
.button:disabled {
  opacity: 0.5;
}
.button:disabled:hover {
  background: #1976d2;
}
.text-center {
  text-align: center;
}
.inline {
  margin: 0;
  padding: 0;
  list-style: none;
}
.inline li {
  display: inline-block;
}
.clear {
  clear: both;
}
form label {
  display: block;
  font-size: 16px;
  margin-bottom: 0.5rem;
}
form input {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
  font-size: 16px;
  padding: 10px;
  outline: 0;
  border: 1px solid #e6ecf0;
  border-radius: 3px;
}
form input:focus {
  box-shadow: 0 0 5px 0 rgba(52, 73, 94, 0.2);
}
form textarea {
  resize: none;
  border: 1px solid #e6ecf0;
  outline: 0;
  height: 100px;
  width: 100%;
  padding: 10px;
  font-size: 16px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#login {
}
@media screen and (max-width: 742px) {
  #login {
    height: 100vh;
    background: #fff;
  }
}
#login .col1,
#login .col2 {
  height: 100vh;
  padding-top: 30vh;
}
@media screen and (max-width: 742px) {
  #login .col1,
  #login .col2 {
    height: auto;
    padding-top: 20vh;
  }
}
#login .col1 {
  color: #fff;
}
@media screen and (max-width: 742px) {
  #login .col1 {
    display: none;
  }
}
#login .col1 p {
  max-width: 490px;
  margin-top: 2rem;
  line-height: 1.8;
}
#login .col1 a {
  color: #fff;
  text-decoration: underline;
}
#login .signup-form {
  padding-top: 20vh;
}
@media screen and (max-width: 742px) {
  #login .signup-form {
    padding-top: 10vh;
  }
}
#login .col2 h1 {
  margin-bottom: 2rem;
}
#login .col2 form {
  max-width: 450px;
  margin: 0 auto;
}
#login .col2 .extras {
  float: right;
  text-align: right;
}
#login .col2 .extras a {
  display: block;
  margin-bottom: 0.5rem;
}
#login .col2 .password-reset h1 {
  margin-bottom: 1rem;
}
#login .col2 .password-reset p {
  margin-bottom: 2rem;
}
</style>
